/* eslint no-console:0 */

import Turbolinks from 'turbolinks';
import 'shared/underscore';
import Rails from '@rails/ujs';

import Vue from 'vue/dist/vue.esm';

import QRCode from 'qrcode';
import Sortable from 'sortablejs/Sortable.min.js';
import SignaturePad from 'signature_pad/dist/signature_pad.min.js';
import Push from 'push.js';
import * as ActionCable from '@rails/actioncable';


window.Turbolinks = Turbolinks;

window.Vue = Vue;

window.QRCode       = QRCode;
window.Sortable     = Sortable;
window.SignaturePad = SignaturePad;
window.Push         = Push;
window.ActionCable  = ActionCable;

Turbolinks.start();
Rails.start();
